import React, { useState, useEffect  } from "react";
import {
  Button,
  Box,
  Typography,
  Paper,
  Grid,
} from '@mui/material';
import { useNavigate } from "react-router-dom";
import BottomImage from "../../components/LoginPages/bottomimage";
import HeaderApp from "../../components/LoginPages/header";
import "./style.css";

const ForgotPasswrod = () => {
  const [email, setEmail] = useState(localStorage.getItem("email") || "");
  const navigate = useNavigate();

  useEffect(() => {
      setEmail(localStorage.getItem("email") || "");
  }, []);

  const handleSubmit = () => {
    navigate("/login");
  };

  return (
    <>
      <HeaderApp type='login' />
      <Grid container justifyContent="center" alignItems="center" sx={{display: "flex", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", zIndex: 1}}>
        <Grid item xs={12} sm={8} md={3.5}>
          <Paper elevation={3} sx={{ padding: "1.6em 3em", display: 'flex', flexDirection: 'column', alignItems: 'center', background:'#fffff', position: 'relative', zIndex: 1, borderRadius: "15px", boxShadow: "rgba(0, 0, 0, 0.1) 0px 7px 49px 0px" }}>
            <Typography sx={{ textAlign: "center", fontWeight: 400, fontSize: '16px', color: "#565555", lineHeight: 2 }}>
                    {/* Time to rescue your account! Your recovery link is chillin’ in {email} . */}
                    Password changed successfully! Please log in using your new password.
            </Typography>
            <Box component="img" src={`${process.env.PUBLIC_URL}/images/mail.gif`} alt="mail" sx={{ height: 120 }} />
            <Button
              variant="contained"
              sx={{
                width: '100%',
                height: 45,
                color: "#fff",
                background: "#185CB7",
                textTransform: "none",
                fontSize: "16px",
                borderRadius: "10px",
                fontWeight: "600",
                "&:hover": { background: "#185CB7" },
              }}
              onClick={handleSubmit}
            >
              Login
            </Button>
          </Paper>
        </Grid>
      </Grid>
      <BottomImage />
    </>
  );
};

export default ForgotPasswrod;
